import { render, staticRenderFns } from "./SaleOrderItem.vue?vue&type=template&id=71053013&scoped=true&"
import script from "./SaleOrderItem.vue?vue&type=script&lang=js&"
export * from "./SaleOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./SaleOrderItem.vue?vue&type=style&index=0&id=71053013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71053013",
  null
  
)

export default component.exports